import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function NikoFacilityOrderConfirmationModalTemplate({ nikoFacilityOrderConfirmationModalStore, t }) {
    const {
        icon,
        title,
        action,
        disabled,
        modalParams,
        additionalMessage
    } = nikoFacilityOrderConfirmationModalStore;

    return (
        <section>
            <div className="modal__body type--center">
                <i className={`status--sqare is-big ${icon} u-mar--bottom--med u-radius--full`} />
                <h3 className='modal__header__title u-mar--bottom--med'>{title}</h3>
                {additionalMessage && <p className='u-mar--bottom--med type--color--secondary'> {additionalMessage} </p>}
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                    disabled={disabled}
                />
                <KeyDownListener onConfirm={action} />
                <BaasicButton
                    className="btn btn--med btn--primary"
                    label={t('EDIT_FORM_LAYOUT.CONFIRM')}
                    onClick={() => action()}
                    disabled={disabled}
                    rotate
                    icon={
                        disabled
                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                            : 'u-display--none'
                    }
                />
            </div>
        </section>
    )
}

NikoFacilityOrderConfirmationModalTemplate.propTypes = {
    nikoFacilityOrderConfirmationModalStore: PropTypes.object,
    t: PropTypes.func
};

const KeyDownListener = ({ onConfirm }) => {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Enter") {
                onConfirm();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return null;
}
KeyDownListener.propTypes = {
};

export default defaultTemplate(NikoFacilityOrderConfirmationModalTemplate);
